module.exports = {
    dpuOverlay: {
        popupWidth: 700,
        popupHeight: 500,
        maxShowPopupTimeInMinutesWithNoResponse: 5, // 5 mins maximum
        popupWindowCheckingFrequency: 1, // how often to check the status of popup window in seconds, 1 = 1 second, 0.8 = 800 milliseconds
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/dpu-overlay.js